/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertMstCenterStockItem } from './AlertMstCenterStockItem';
import {
    AlertMstCenterStockItemFromJSON,
    AlertMstCenterStockItemFromJSONTyped,
    AlertMstCenterStockItemToJSON,
    AlertMstCenterStockItemToJSONTyped,
} from './AlertMstCenterStockItem';

/**
 * 
 * @export
 * @interface AlertCenterStockItemData
 */
export interface AlertCenterStockItemData {
    /**
     * 
     * @type {number}
     * @memberof AlertCenterStockItemData
     */
    datacount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AlertCenterStockItemData
     */
    maxcount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertCenterStockItemData
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {Array<AlertMstCenterStockItem>}
     * @memberof AlertCenterStockItemData
     */
    list: Array<AlertMstCenterStockItem>;
}

/**
 * Check if a given object implements the AlertCenterStockItemData interface.
 */
export function instanceOfAlertCenterStockItemData(value: object): value is AlertCenterStockItemData {
    if (!('datacount' in value) || value['datacount'] === undefined) return false;
    if (!('maxcount' in value) || value['maxcount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    return true;
}

export function AlertCenterStockItemDataFromJSON(json: any): AlertCenterStockItemData {
    return AlertCenterStockItemDataFromJSONTyped(json, false);
}

export function AlertCenterStockItemDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertCenterStockItemData {
    if (json == null) {
        return json;
    }
    return {
        
        'datacount': json['datacount'],
        'maxcount': json['maxcount'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'list': ((json['list'] as Array<any>).map(AlertMstCenterStockItemFromJSON)),
    };
}

export function AlertCenterStockItemDataToJSON(json: any): AlertCenterStockItemData {
    return AlertCenterStockItemDataToJSONTyped(json, false);
}

export function AlertCenterStockItemDataToJSONTyped(value?: AlertCenterStockItemData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datacount': value['datacount'],
        'maxcount': value['maxcount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'list': ((value['list'] as Array<any>).map(AlertMstCenterStockItemToJSON)),
    };
}

